var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }) : _vm.isHolding(_vm.loggedUserData) ? _c("ConsultantOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }) : _vm._e(), _vm.selectedTab === _vm.tabs.orders ? _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminOrderList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isConsultantOrHolding(_vm.loggedUserData) ? _c("ConsultantOrderList", {
    attrs: {
      filters: true,
      searchCriterias: _vm.searchCriterias,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.canAccessSourcing && _vm.selectedTab === _vm.tabs.sourcing ? _c("div", [_c("SourcingList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.inboundDeliveries ? _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminInboundDeliveryList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.creditNote ? _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("CreditNoteListAdmin", {
    attrs: {
      filters: true,
      searchCriterias: _vm.searchCriterias,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm.isHolding(_vm.loggedUserData) ? _c("CreditNoteListHolding", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      searchCriterias: _vm.searchCriterias
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.factoringProviders ? _c("div", [_c("FactoringProviderList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };